<template>
  <div class="eSanchit-products">
    <div class="settings--title fs-25 black--text font-weight-medium">
      ESanchit Master
    </div>
    <v-card elevation="4" class="px-8 py-6 mt-4">
          <v-row
          class="loader fill-height py-6"
          align="center"
          justify="center"
          v-if="loading"
        >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      <div v-else>
      <div class="eSanchit-products-body__header--button" :class="{ 'mt-3': breakpointXs }">
        <v-btn
          width="250"
          v-if="isPreviousJobAvailable"
          color="button-primary"
          large
          class="white--text"
          @click="moveToPreviousJob"
        >
          <v-icon left>fas fa-left</v-icon>
          <span class="font-weight-bold fs-15">Move to Previous Job</span>
        </v-btn>
      </div>
      <div class="eSanchit-products-body mt-6 mb-6" :class="{ 'pa-5': xsOrsm, 'pa-6': breakpointMd, 'pa-8': xlOrlg }">
        <div class="eSanchit-products-body__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
          <div class="eSanchit-products-body__header--title fs-20 fw-600">
            Master Details
          </div>

          <v-spacer v-if="!breakpointXs"></v-spacer>
          <div class="eSanchit-products-body__header__search" :class="{ 'mt-3': breakpointXs, 'mr-4': !breakpointXs }">
            <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
          </div>
          <div class="eSanchit-products-body__header--button" :class="{ 'mt-3': breakpointXs }">
            <v-btn width="180" color="button-primary" large class="white--text" @click="addNewSupportingDoc">
              <v-icon left>fas fa-plus</v-icon>
              <span class="font-weight-bold fs-15">Add New</span>
            </v-btn>
          </div>
        </div>
        <v-flex class="eSanchit-products-body__table mt-4">
          <v-data-table :headers="tableHeaders" :loading="isESanchitProductsFormLoading" :items="supportingDocs" :search="search" :items-per-page="10">
            <template v-slot:item.edit="{ item }">
              <v-row>
                <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-right">
                  <v-btn color="lightPrimary" class="info font-weight-bold" dense @click="editActionHandler(item)"
                    >Edit</v-btn
                  >
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-row>
                <v-col cols="12" :xs="6" :sm="6" :md="6" :lg="6" class="text-left">
                  <v-btn color="lightPrimary" class=" error font-weight-bold" dense @click="deleteActionHandler(item)"
                    >Delete</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-flex>
      </div>
      </div>
    </v-card>
    <ConfirmDeleteDialog
      @clicked-yes="deleteSupportingDoc"
      :loader="isESanchitProductsFormLoading"
      @clicked-no="showConfirmationDialog = false"
      v-if="showConfirmationDialog"
    />
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
            Add E-Sanchit
          </div>
          <v-btn v-if="!breakpointXs" icon @click="dialog = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="imgReferenceNo"
                  rules="required|max:16"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isESanchitProductsFormLoading"
                  label="Image Ref. No (IRN)"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentReferenceNo"
                  rules="required|max:17"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isESanchitProductsFormLoading"
                  label="Document Ref. No (DRN)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentName"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isESanchitProductsFormLoading"
                  label="Document Name"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="documentTypeCode"
                  item-text="documentName"
                  item-value="documentCode"
                  :items="documentTypeCodes"
                  :loading="isESanchitProductsFormLoading"
                  label="Document Type"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="icegateFileName"
                  :loading="isESanchitProductsFormLoading"
                  label="Icegate Filename"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField v-model="placeOfIssue" :loading="isESanchitProductsFormLoading" label="Place of issue" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <DateField
                  v-model="documentIssueDate"
                  required
                  :loading="isESanchitProductsFormLoading"
                  :inputLabel="'Document Issue Date'"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <DateField
                  v-model="documentExpiryDate"
                  :loading="isESanchitProductsFormLoading"
                  :inputLabel="'Document Expiry Date'"
                />
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <!-- Issuer and Beneficiary party details -->
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <AutoComplete
                  v-model="documentIssuingPartyName"
                  required
                  showIcons
                  :item-text="'name'"
                  :return-object="true"
                  :items="exporters"
                  rules="required"
                  :loading="isESanchitProductsFormLoading"
                  label="Issuer Party Name"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentBeneficiaryPartyName"
                  required
                  :loading="isESanchitProductsFormLoading"
                  label="Beneficiary Party Name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentIssuingPartyCode"
                  :loading="isESanchitProductsFormLoading"
                  label="Issuer Party Code"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentBeneficiaryPartyCode"
                  :loading="isESanchitProductsFormLoading"
                  label="Beneficiary Party Code"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentIssuingPartyNameAddress1"
                  required
                  :loading="isESanchitProductsFormLoading"
                  label="Issuer Party Address"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentBeneficiaryPartyNameAddress1"
                  required
                  :loading="isESanchitProductsFormLoading"
                  label="Beneficiary Party Address"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentIssuingPartyNameCity"
                  :loading="isESanchitProductsFormLoading"
                  label="Issuer Party City"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentBeneficiaryPartyNameCity"
                  :loading="isESanchitProductsFormLoading"
                  label="Beneficiary Party City"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentIssuingPartyNamePin"
                  :loading="isESanchitProductsFormLoading"
                  label="Issuer Party Pin"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="documentBeneficiaryPartyNamePin"
                  :loading="isESanchitProductsFormLoading"
                  label="Beneficiary Party Pin"
                />
              </v-col>
            </v-row>
            <div class="d-block d-sm-flex justify-end">
              <v-btn
                color="button-primary"
                outlined
                :block="breakpointXs"
                large
                width="140"
                :loading="isESanchitProductsFormLoading"
                :class="{ 'my-3 mr-3': !breakpointXs }"
                @click="dialog = false"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                v-if="!editOption"
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isESanchitProductsFormLoading"
                @click="passes(addSupportingDoc)"
              >
                <span class="font-weight-bold fs-15">Add</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                v-if="editOption"
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isESanchitProductsFormLoading"
                @click="passes(updateSupportingDoc)"
              >
                <span class="font-weight-bold fs-15">Update</span>
              </v-btn>
            </div>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
import AutoComplete from "@/components/AutoComplete";
import * as AT from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import { GET_ESANCHIT_SUPPORTING_DOC } from "@/modules/DashboardModule/modules/ImportExportModule/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "ESanchit",
  components: {
    ValidationObserver,
    ConfirmDeleteDialog,
    TextField,
    DateField,
    AutoComplete
  },
  mounted() {
    this.checkPreviousJobAvailable();
  },
  data() {
    return {
      showConfirmationDialog: false,
      isESanchitProductsFormLoading: false,
      isPreviousJobAvailable: false,
      search: "",
      loading: false,
      dialog: false,
      imgReferenceNo: null,
      documentReferenceNo: null,
      documentName: null,
      documentTypeCode: null,
      icegateFileName: null,
      placeOfIssue: null,
      documentIssueDate: null,
      documentExpiryDate: null,
      documentBeneficiaryPartyName: null,
      documentIssuingPartyCode: null,
      documentBeneficiaryPartyCode: null,
      documentIssuingPartyNameAddress1: null,
      documentBeneficiaryPartyNameAddress1: null,
      documentIssuingPartyNameCity: null,
      documentBeneficiaryPartyNameCity: null,
      documentIssuingPartyNamePin: null,
      documentBeneficiaryPartyNamePin: null,
      deleteItemCall: null,
      updateItemCall: null,
      editOption: false
    };
  },
    watch: {
    globalTimePeriodId(newVal, oldVal) {
      if (newVal !== null) {
        oldVal;
        this.getEsanchits(newVal);
      }
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    onScroll(e) {
      this.scrollSync.top = e.target.scrollTop;
      this.scrollSync.left = e.target.scrollLeft;
    },
    moveToPreviousJob() {
      const exportJobId = this.$store.state.ExportModuleStore.exportJobId;
      if (exportJobId !== null) {
        this.$router.push({ path: "/dashboard/export/" + exportJobId + "/supporting-doc" });
      }
    },
    checkPreviousJobAvailable() {
      const exportJobId = this.$store.state.ExportModuleStore.exportJobId;
      if (exportJobId !== null) {
        this.isPreviousJobAvailable = true;
      }
    },
    addNewSupportingDoc() {
      this.imgReferenceNo = null;
      this.documentReferenceNo = null;
      this.documentName = null;
      this.documentTypeCode = null;
      this.icegateFileName = null;
      this.placeOfIssue = null;
      this.documentBeneficiaryPartyName = null;
      this.documentIssuingPartyCode = null;
      this.documentBeneficiaryPartyCode = null;
      this.documentIssuingPartyNameAddress1 = null;
      this.documentBeneficiaryPartyNameAddress1 = null;
      this.documentIssuingPartyNameCity = null;
      this.documentIssuingPartyName = "";
      this.documentBeneficiaryPartyNameCity = null;
      this.documentIssuingPartyNamePin = null;
      this.documentBeneficiaryPartyNamePin = null;
      this.editOption = false;
      this.dialog = true;
    },
    getSupportingDocFormData() {
      return {
        time_period_id: this.$store.getters.globalTimePeriod,
        imgReferenceNo: this.imgReferenceNo,
        documentReferenceNo: this.documentReferenceNo,
        documentName: this.documentName,
        documentTypeCode: this.documentTypeCode,
        icegateFileName: this.icegateFileName,
        placeOfIssue: this.placeOfIssue,
        documentIssueDate: this.documentIssueDate,
        documentExpiryDate: this.documentExpiryDate,
        documentIssuingPartyName: this.documentIssuingPartyName,
        documentBeneficiaryPartyName: this.documentBeneficiaryPartyName,
        documentIssuingPartyCode: this.documentIssuingPartyCode,
        documentBeneficiaryPartyCode: this.documentBeneficiaryPartyCode,
        documentIssuingPartyNameAddress1: this.documentIssuingPartyNameAddress1,
        documentBeneficiaryPartyNameAddress1: this.documentBeneficiaryPartyNameAddress1,
        documentIssuingPartyNameCity: this.documentIssuingPartyNameCity,
        documentBeneficiaryPartyNameCity: this.documentBeneficiaryPartyNameCity,
        documentIssuingPartyNamePin: this.documentIssuingPartyNamePin,
        documentBeneficiaryPartyNamePin: this.documentBeneficiaryPartyNamePin,
        icegateId: this.$store.getters.account.icegate_id
      };
    },
    makeSupportingDocFromResponse(response, id) {
      return {
        id: id,
        imgReferenceNo: response.imgReferenceNo,
        documentReferenceNo: response.documentReferenceNo,
        documentName: response.documentName,
        documentTypeCode: response.documentTypeCode,
        icegateFileName: response.icegateFileName,
        placeOfIssue: response.placeOfIssue,
        documentIssueDate: response.documentIssueDate,
        documentExpiryDate: response.documentExpiryDate,
        documentIssuingPartyName: response.documentIssuingPartyName,
        documentBeneficiaryPartyName: response.documentBeneficiaryPartyName,
        documentIssuingPartyCode: response.documentIssuingPartyCode,
        documentBeneficiaryPartyCode: response.documentBeneficiaryPartyCode,
        documentIssuingPartyNameAddress1: response.documentIssuingPartyNameAddress1,
        documentBeneficiaryPartyNameAddress1: response.documentBeneficiaryPartyNameAddress1,
        documentIssuingPartyNameCity: response.documentIssuingPartyNameCity,
        documentBeneficiaryPartyNameCity: response.documentBeneficiaryPartyNameCity,
        documentIssuingPartyNamePin: response.documentIssuingPartyNamePin,
        documentBeneficiaryPartyNamePin: response.documentBeneficiaryPartyNamePin,
        icegateId: response.icegateId
      };
    },
    editSupportingDocForm(item) {
      (this.imgReferenceNo = item.imgReferenceNo),
        (this.documentReferenceNo = item.documentReferenceNo),
        (this.documentName = item.documentName),
        (this.documentTypeCode = item.documentTypeCode),
        (this.icegateFileName = item.icegateFileName),
        (this.placeOfIssue = item.placeOfIssue),
        (this.documentIssueDate = item.documentIssueDate),
        (this.documentExpiryDate = item.documentExpiryDate),
        (this.documentIssuingPartyName = item.documentIssuingPartyName),
        (this.documentBeneficiaryPartyName = item.documentBeneficiaryPartyName),
        (this.documentIssuingPartyCode = item.documentIssuingPartyCode),
        (this.documentBeneficiaryPartyCode = item.documentBeneficiaryPartyCode),
        (this.documentIssuingPartyNameAddress1 = item.documentIssuingPartyNameAddress1),
        (this.documentBeneficiaryPartyNameAddress1 = item.documentBeneficiaryPartyNameAddress1),
        (this.documentIssuingPartyNameCity = item.documentIssuingPartyNameCity),
        (this.documentBeneficiaryPartyNameCity = item.documentBeneficiaryPartyNameCity),
        (this.documentIssuingPartyNamePin = item.documentIssuingPartyNamePin),
        (this.documentBeneficiaryPartyNamePin = item.documentBeneficiaryPartyNamePin);
      if (this.documentIssuingPartyName !== null) {
        const exporterObj = this.exporters.find(exporter => exporter.name == item.documentIssuingPartyName);
        if (exporterObj !== undefined) {
          // again resetting to set adCodes
          this.documentIssuingPartyName = exporterObj;
        }
        return;
      }
    },
    deleteActionHandler(item) {
      this.deleteItemCall = { ...item };
      this.showConfirmationDialog = true;
      return;
    },
    editActionHandler(item) {
      this.updateItemCall = item.id;
      this.editOption = true;
      this.editSupportingDocForm(item);
      this.dialog = true;
    },
    getEsanchits(timePeriodId) {
        this.isESanchitProductsFormLoading = true;
      this.$store.dispatch(GET_ESANCHIT_SUPPORTING_DOC, timePeriodId)
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isESanchitProductsFormLoading = false;
        });
    },
    updateSupportingDoc() {
      this.isESanchitProductsFormLoading = true;
      const formData = {
        id: this.updateItemCall,
        time_period_id: this.$store.getters.globalTimePeriod,
        json_data: this.getSupportingDocFormData()
      };
      this.$store
        .dispatch(AT.UPDATE_ESANCHIT_SUPPORTING_DOC, formData)
        .then(res => {
          const supportingDocObj = this.supportingDocs.find(supportingDoc => supportingDoc.id == res.id);
          if (supportingDocObj !== undefined) {
            Object.assign(supportingDocObj, {
              ...this.makeSupportingDocFromResponse(res.json_data, res.id)
            });
            return;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.dialog = false;
          this.isESanchitProductsFormLoading = false;
        });
    },
    addSupportingDoc() {
      this.isESanchitProductsFormLoading = true;
      const formData = {
        time_period_id: this.$store.getters.globalTimePeriod,
        json_data: this.getSupportingDocFormData()
      };
      this.$store
        .dispatch(AT.ADD_ESANCHIT_SUPPORTING_DOC, formData)
        .then(res => {
          if (res) {
            this.supportingDocs.push(this.makeSupportingDocFromResponse(res.json_data, res.id));
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.dialog = false;
          this.isESanchitProductsFormLoading = false;
        });
    },
    deleteSupportingDoc() {
      this.isESanchitProductsFormLoading = true;
      this.$store
        .dispatch(AT.DELETE_ESANCHIT_SUPPORTING_DOC, this.deleteItemCall.id)
        .then(() => {
          this.supportingDocs.splice(
            this.supportingDocs.findIndex(supportingDoc => supportingDoc.id === this.deleteItemCall.id),
            1
          );
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isESanchitProductsFormLoading = false;
          this.showConfirmationDialog = false;
          this.deleteItemCall = null;
        });
    }
  },
  computed: {
    supportingDocs() {
      return this.$store.getters.esanchitSupportingDocs;
    },
    documentIssuingPartyName: {
      get() {
        return this.$store.state.ExportModuleStore.supportingDoc.documentIssuingPartyName;
      },
      set(value) {
        value.address1 !== undefined ? (this.documentIssuingPartyNameAddress1 = value.address1) : null;
        value.city !== undefined ? (this.documentIssuingPartyNameCity = value.city) : null;
        value.state !== undefined ? (this.state = value.state) : null;
        value.pin !== undefined ? (this.documentIssuingPartyNamePin = value.pin) : null;
        this.$store.commit(MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME, { value: value.name });
      }
    },
    tableHeaders() {
      return [
        { text: "Image Ref. No (IRN)", value: "imgReferenceNo", align: "center" },
        { text: "Document Type", value: "documentTypeCode", align: "center" },
        { text: "Issued At", value: "placeOfIssue", align: "center" },
        { text: "Issued By", value: "documentIssuingPartyName", align: "center" },
        { text: "Issue Date", value: "documentIssueDate", align: "center" },
        { text: "Expiry Date", value: "documentExpiryDate", align: "center" },
        { text: "ICEGATE Filename", value: "icegateFileName", align: "center" },
        { text: "Doc Ref. No", value: "documentReferenceNo", align: "center" },
        { text: "Beneficiary Party", value: "documentBeneficiaryPartyName", align: "center" },
        { text: "Edit", value: "edit", align: "center" },
        { text: "Delete", value: "delete", align: "center" }
      ];
    },
    eSanchits() {
      return [];
    },
    exporters() {
      return this.$store.getters.exporters;
    },
    documentTypeCodes() {
      return this.$store.getters.documentTypeCodes;
    }
  }
};
</script>
<style lang="scss">
@import "../../../styles/settings/index";

.eSanchit-products {
  .eSanchit-products-body {
    border: 2px solid $border-grey;
    border-radius: 10px;
    &__table {
      .v-data-table {
        background: transparent !important;
      }
    }
  }
}
</style>
